import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import type { ITicket, ITicketMessage, ITicketStats, ITicketFilter } from "./tickets-types";

function getHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("tokenSession"),
  };
}

const api = axios.create({ baseURL: ROOT_URL, withCredentials: false });

export function getTickets(
  params: ITicketFilter
): Promise<{ tickets: ITicket[]; total: number }> {
  return api
    .get("/api/help/tickets", { headers: getHeaders(), params })
    .then((res) => res.data);
}

export function getTicketStats(): Promise<ITicketStats> {
  return api
    .get("/api/help/tickets/stats", { headers: getHeaders() })
    .then((res) => res.data);
}

export function getTicket(uuid: string): Promise<ITicket> {
  return api
    .get(`/api/help/tickets/${uuid}`, { headers: getHeaders() })
    .then((res) => res.data);
}

export function updateTicketStatus(
  uuid: string,
  status: string
): Promise<void> {
  return api
    .put(`/api/help/tickets/${uuid}/status`, { status }, { headers: getHeaders() })
    .then(() => undefined);
}

export function updateTicketPriority(
  uuid: string,
  priority: string
): Promise<void> {
  return api
    .put(`/api/help/tickets/${uuid}/priority`, { priority }, { headers: getHeaders() })
    .then(() => undefined);
}

export function deleteTicket(uuid: string, reason: string): Promise<void> {
  return api
    .delete(`/api/help/tickets/${uuid}`, {
      headers: getHeaders(),
      data: { reason },
    })
    .then(() => undefined);
}

export function restoreTicket(uuid: string): Promise<void> {
  return api
    .post(`/api/help/tickets/${uuid}/restore`, undefined, { headers: getHeaders() })
    .then(() => undefined);
}

export function blockTicket(uuid: string, reason: string): Promise<void> {
  return api
    .put(`/api/help/tickets/${uuid}/block`, { reason }, { headers: getHeaders() })
    .then(() => undefined);
}

export function unblockTicket(uuid: string): Promise<void> {
  return api
    .put(`/api/help/tickets/${uuid}/unblock`, undefined, { headers: getHeaders() })
    .then(() => undefined);
}

export function getMessages(uuid: string): Promise<ITicketMessage[]> {
  return api
    .get(`/api/help/tickets/${uuid}/messages`, { headers: getHeaders() })
    .then((res) => res.data);
}

export function addSupportMessage(
  uuid: string,
  message: string
): Promise<ITicketMessage> {
  return api
    .post(
      `/api/help/tickets/${uuid}/messages`,
      { message },
      { headers: getHeaders() }
    )
    .then((res) => res.data);
}

export function deleteMessage(uuid: string, reason: string): Promise<void> {
  return api
    .delete(`/api/help/tickets/messages/${uuid}`, {
      headers: getHeaders(),
      data: { reason },
    })
    .then(() => undefined);
}

export function restoreMessage(uuid: string): Promise<void> {
  return api
    .post(`/api/help/tickets/messages/${uuid}/restore`, undefined, {
      headers: getHeaders(),
    })
    .then(() => undefined);
}

export function downloadFile(uuid: string): Promise<Blob> {
  return api
    .get(`/api/help/tickets/files/${uuid}/download`, {
      headers: getHeaders(),
      responseType: "blob",
    })
    .then((res) => res.data);
}
